import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AlertService } from '../alert/alert.service';
import { AuthFlowMessages } from './constants/auth-flow-messages';
import { ApiRouteConstants } from '../../constants/api-routes';

/**
 * This service centralizes all authentication flows using the CEVO API for the application.
 * It provides a single point of interaction with the API, ensuring consistent behavior
 * across all components and services that require authentication functionality that only can
 * be done using the CEVO API.
 */
@Injectable({
    providedIn: 'root',
})
export class AuthFlowApiService {
    constructor(
        private readonly alertService: AlertService,
        private readonly http: HttpClient,
    ) {}

    /**
     * Triggers a password reset flow by sending a POST request to the CEVO API's Auth0 endpoint.
     * Upon success, it displays a success alert to the user that an email has been sent to them
     * with instructions to reset their password.
     */
    triggerPasswordReset(): void {
        this.http.post(ApiRouteConstants.Auth.resetPassword, null).subscribe({
            next: () => {
                this.alertService.displaySuccessAlert(
                    AuthFlowMessages.passwordReset.emailSuccessfullySentMessage,
                    false,
                );
            },
        });
    }
}
